import * as React from "react";
import { Grid, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";

function SliderPopUp({ setIsSlideOpen, setIsClick }) {
  const navigate = useNavigate();
  return (
    <Grid
      sx={{
        width: 250,
        backgroundColor: "#414851",
        zIndex: 100,
        position: "absolute",
        top: 185,
        left: 100,
        borderRadius: "14px",
        border: "3px solid #17dfba",
      }}>
      <Grid
        onClick={() => {
          setIsClick(false);
          setIsSlideOpen(false);
          navigate("/addhospital", {
            state: { addNew: true },
            replace: true,
          });
        }}
        item
        lg={12}
        sx={{
          height: 45,
          paddingLeft: "30px ",
          cursor: "pointer",
          "&:hover": {
            background: "#17dfba",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            color: "black",
          },
        }}
        container
        alignItems={"center"}>
        <Typography sx={{ color: "white" }}>Add New Hospital</Typography>
      </Grid>
      <Divider light />
      <Grid
        onClick={() => {
          setIsClick(false);
          setIsSlideOpen(false);
          navigate(
            "/adddoctor",
            { replace: true }
            // window.location.reload()
          );
        }}
        item
        lg={12}
        sx={{
          height: 45,
          paddingLeft: "30px ",
          cursor: "pointer",
          "&:hover": {
            background: "#17dfba",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            color: "black",
          },
        }}
        container
        alignItems={"center"}>
        <Typography sx={{ color: "white" }}>Add New Doctor</Typography>
      </Grid>{" "}
    </Grid>
  );
}
export default SliderPopUp;
